<template>
  <div>
    <HeadBannerHigh
      v-if="$store.state.selected_menu"
      :itemData="$store.state.selected_menu"
    />
    <Breadcrumb />

    <section class="container business-model unique-component">
      <div class="overview-container row-standard flex-box reversed">
        <intersect @enter="animate4 = true">
          <div class="overview-left fadeUp" :class="animate4 ? 'animate' : ''">
            <div class="form-container br-12" :class="hideImg ? 'next-step' : ''">

              <div class="img-box">
                <picture>
                  <source
                    media="(max-width: 767px)"
                    :srcset="
                      _.get(
                        $store.state.current_content,
                        'primary.0.images.0.devices.mobile'
                      )
                    "
                  />
                  <source
                    media="(max-width: 1023px)"
                    :srcset="
                      _.get(
                        $store.state.current_content,
                        'primary.0.images.0.devices.tablet'
                      )
                    "
                  />
                  <img
                    :src="
                      _.get(
                        $store.state.current_content,
                        'primary.0.images.0.devices.desktop'
                      )
                    "
                    class="img-absolute br-12"
                    alt
                  />
                </picture>
                <div class="gradient br-12"></div>
                <div class="form-banner-content">
                  <h4 class="font-34 noto-semibold white">
                    {{_.get( $store.state.current_content, 'primary.0.form_title' )}}
                  </h4>
<!--                  <p class="text white">{{ $fn.tr("Find some tips") }}</p>-->
                  <div class="enter btn sub bg-white" id="enterBtn" v-on:click="hideImg = !hideImg">
                    {{ $fn.tr("Enter") }}
                  </div>
                </div>
              </div>
              <h3 class="other-title">{{_.get( $store.state.current_content, 'primary.0.form_title' )}}</h3>
              <el-form
                  v-if="formStatus=='show-form'"
                action
                class="member-form flex-box column"
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
              >
                <el-form-item
                    v-if="_.get( $store.state.current_content, 'primary.0.name' )"
                  for="name"
                  class="flex-box column font-12 noto-semibold"
                  prop="name"
                >
                  {{ _.get( $store.state.current_content, 'primary.0.name' ) }}
                  <el-input
                    type="text"
                    name="name"
                    :placeholder="_.get( $store.state.current_content, 'primary.0.name' )"
                    v-model="ruleForm.name"
                  ></el-input>
                </el-form-item>

                <el-form-item
                    v-if="_.get( $store.state.current_content, 'primary.0.email' )"
                  for="email"
                  class="flex-box column font-12 noto-semibold error"
                  prop="email"
                >
                  {{ _.get( $store.state.current_content, 'primary.0.email' ) }}
                  <el-input
                    type="email"
                    name="email"
                    :placeholder="_.get( $store.state.current_content, 'primary.0.email' )"
                    v-model="ruleForm.email"
                  ></el-input>
                </el-form-item>

                <el-form-item
                    v-if="_.get( $store.state.current_content, 'primary.0.phone' )"
                  for="phone"
                  class="flex-box column font-12 noto-semibold"
                  prop="phone"
                >
                  {{ _.get( $store.state.current_content, 'primary.0.phone' ) }}
                  <el-input
                    type="number"
                    name="phone"
                    :placeholder="_.get( $store.state.current_content, 'primary.0.phone' )"
                    v-model="ruleForm.phone"
                  ></el-input>
                  <div class="error-msg noto-semibold font-12">
                    {{ $fn.tr("error msg") }}
                  </div>
                </el-form-item>

                <el-form-item
                    v-if="_.get( $store.state.current_content, 'primary.0.private_id' )"
                  for="private_id"
                  class="flex-box column font-12 noto-semibold"
                  prop="private_id"
                >
                  {{ _.get( $store.state.current_content, 'primary.0.private_id' ) }}
                  <el-input
                    type="number"
                    name="private_id"
                    :placeholder="_.get( $store.state.current_content, 'primary.0.private_id' )"
                    v-model="ruleForm.private_id"
                  ></el-input>
                  <div class="error-msg noto-semibold font-12">
                    {{ $fn.tr("error msg") }}
                  </div>
                </el-form-item>

                <el-form-item
                  v-if="_.get($store.state.current_content, 'primary.0.slug') === 'premium-banking'"
                  class="flex-box column font-12 noto-semibold"
                >
                    {{ $fn.tr("choose branch") }}
                    <CustomSelect :options="branchList[_.get($store.state, 'locale')]" v-model="selectedBranch" :isBranch="true" />
                </el-form-item>

                <el-form-item
                    v-if="_.get( $store.state.current_content, 'primary.0.comment' )"
                  for="comment"
                  class="flex-box column font-12 noto-semibold"
                  prop="comment"
                >
                  {{ _.get( $store.state.current_content, 'primary.0.comment' ) }}
                  <el-input
                    type="textarea"
                    name="comment"
                    maxlength="200"
                    :placeholder="_.get( $store.state.current_content, 'primary.0.comment' )"
                    v-model="ruleForm.comment"
                  ></el-input>
                  <div class="error-msg noto-semibold font-12">
                    {{ $fn.tr("error msg") }}
                  </div>
                </el-form-item>
                <p class="font-12">
                  {{_.get( $store.state.current_content, 'primary.0.form_desctiption' )}}
                </p>

                <div class="form-end flex-box">
                  <div class="captcha">
                    <vue-recaptcha
                        :sitekey="_.get($store.state.indx, 'nocapcha.sitekey')"
                        :loadRecaptchaScript="true"
                        @verify="onVerify"
                    ></vue-recaptcha>
                  </div>
                </div>

                <div class="form-end flex-box">
                  <el-button class="btn sub white ml-0" type="primary" @click="submitForm()" >{{ $fn.tr("Send") }}</el-button>
                </div>

              </el-form>
              <div class="success-msg br-12" v-show="formStatus=='show-thank-text'">
                <h5 class="noto-bold font-34">{{ $fn.tr("Thank you!") }}</h5>
                <p class="text">
                  {{_.get( $store.state.current_content, 'primary.0.thanks_text' )}}
                </p>
                <button class="reset-btn btn white" @click="resetForm">{{ $fn.tr("Reset") }}</button>
              </div>
            </div>
          </div>
        </intersect>

        <div class="overview-right">
          <intersect @enter="animate5 = true">
            <h2 class="main-title fadeUp" :class="animate5 ? 'animate' : ''">
              {{ _.get( $store.state.current_content, "primary.0.content.tabs.0.title")}}
            </h2>
          </intersect>

          <intersect @enter="animate6 = true">
            <div
              class="text fadeUp"
              v-html="_.get( $store.state.current_content, 'primary.0.content.tabs.0.content' )"
              :class="animate6 ? 'animate' : ''"
            ></div>
          </intersect>
        </div>
      </div>
    </section>

    <NewsBlock
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.NewsBlock.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(this.$store.state.current_content, 'secondary.NewsBlock')
      "
    />
    <MoreWaysForBanking />
  </div>
</template>

<script>
import mainMixin from "@/mixins/main";
import HeadBannerHigh from "@/components/HeadBannerHigh";
import Breadcrumb from "@/components/Breadcrumb";
import SmallTabs from "@/components/SmallTabs";
import NewsBlock from "@/components/NewsBlock";
import MoreWaysForBanking from "@/components/MoreWaysForBanking";
import Intersect from "vue-intersect";
import VueRecaptcha from "vue-recaptcha";
import CustomSelect from "@/components/CustomSelect";
// import { required, minLength, maxLength, numeric, email } from 'vuelidate/lib/validators'

export default {
  components: {
    HeadBannerHigh,
    Breadcrumb,
    SmallTabs,
    NewsBlock,
    MoreWaysForBanking,
    Intersect,
    VueRecaptcha,
    CustomSelect,
  },
  mixins: [mainMixin],
  data() {
    return {
      formStatus: 'show-form',
      animate: false,
      animate2: false,
      animate3: false,
      animate4: false,
      animate5: false,
      animate6: false,
      hideImg: false,
      ruleForm: {
        name: "",
        email: "",
        private_id: "",
        phone: "",
        comment: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$fn.tr("miutite")+' '+_.get( this.$store.state.current_content, 'primary.0.name' ),
            trigger: "blur",
          },
        ],
        email: [
          { required: true,
            message: this.$fn.tr("miutite")+' '+_.get( this.$store.state.current_content, 'primary.0.email' ),
          },
          {
            type: 'email',
            message: this.$fn.tr("Please enter a valid email address"),
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: this.$fn.tr("miutite")+' '+_.get( this.$store.state.current_content, 'primary.0.phone' ),
            trigger: "blur",
          },
        ],

        private_id: [
          {
            required: false,
            message: this.$fn.tr("miutite")+' '+_.get( this.$store.state.current_content, 'primary.0.private_id' ),
            trigger: "blur",
          },
        ],


        comment: [
          { required: false,
            message: this.$fn.tr("miutite")+' '+_.get( this.$store.state.current_content, 'primary.0.comment' ),
          },
          {
            min: 3,
            max: 200,
            message: this.$fn.tr("Length should be 3 to 200"),
            trigger: "blur",
          },
        ],
      },
      selectedBranch: 0,
      branchList: {
        ge: [
						{
						    title: "თბილისი, წმ. ქეთევან დედოფლის გამზ. 1",
						    id: "0",
						},
						{
							title: "თბილისი, ი. ჭავჭავაძის გამზ. 2",
							id: "1",
						},
						{
							title: "თბილისი, ი. ჭავჭავაძის გამზ. 41",
							id: "2",
						},
						{
							title: "თბილისი, ვაჟა-ფშაველას გამზ. 21",
							id: "3",
						},
						{
							title: "თბილისი, ვაჟა-ფშაველას გამზ. 58",
							id: "4",
						},
						{
							title: "თბილისი, პეკინის ქ. 24ა",
							id: "5",
						},
						{
							title: "თბილისი, ა. წერეთლის გამზ. 67",
							id: "6",
						},
						{
							title: "თბილისი, ა. წერეთლის გამზ. 112",
							id: "7",
						},
						{
							title: "თბილისი, ხიზანიშვილის ქ. 1",
							id: "8",
						},
						{
							title: "თბილისი, ვარკეთილის ბიზნესცენტრი",
							id: "9",
						},
						{
							title: "თბილისი, ჯუმბერ ლეჟავას ქ. 22",
							id: "10",
						},
						{
							title: "ბათუმი, ფარნავაზ მეფის ქ. 55",
							id: "11",
						},
						{
							title: "ბათუმი, ი. ჭავჭავაძის ქ. 103",
							id: "12",
						},
						{
							title: "ზუგდიდი, ზ. გამსახურდიას ქ. 31",
							id: "13",
						},
						{
							title: "ქუთაისი, რუსთაველის ქ. 5",
							id: "14",
						},
						{
							title: "თელავი, ერეკლე მეორეს მოედანი 2",
							id: "15",
						},
						{
							title: "რუსთავი, მეგობრობის გამზ. 5",
							id: "16",
						},
						{
							title: "გორი, სტალინის ქ. 29",
							id: "17",
						},
					],
					en: [
						{
						    title: "1, St. Queen Ketevan Ave. Tbilisi",
						    id: "0",
						},
						{
							title: "2, I. Chavchavadze Ave. Tbilisi",
							id: "1",
						},
						{
							title: "41, I. Chavchavadze Ave. Tbilisi",
							id: "2",
						},
						{
							title: "21, Vazha-Phshavela Ave. Tbilisi",
							id: "3",
						},
						{
							title: "58, Vazha-Phshavela Ave. Tbilisi",
							id: "4",
						},
						{
							title: "24a, Pekini St. Tbilisi",
							id: "5",
						},
						{
							title: "67, A. Tsereteli Ave. Tbilisi",
							id: "6",
						},
						{
							title: "112, A. Tsereteli Ave. Tbilisi",
							id: "7",
						},
						{
							title: "1, Khizanishvili St. Tbilisi",
							id: "8",
						},
						{
							title: "Varketili Business Center, Tbilisi",
							id: "9",
						},
						{
							title: "22, Jumber Lezhava St. Tbilisi",
							id: "10",
						},
						{
							title: "55, Pharnavaz Mephe St. Batumi",
							id: "11",
						},
						{
							title: "103, I. Chavchavadze St. Batumi",
							id: "12",
						},
						{
							title: "31, Z. Gamsakhurdia St. Zugdidi",
							id: "13",
						},
						{
							title: "5, Rustaveli St. Kutaisi",
							id: "14",
						},
						{
							title: "2, Erekle Meore Square, Telavi",
							id: "15",
						},
						{
							title: "5, Megobroba Ave. Rustavi",
							id: "16",
						},
						{
							title: "29, Stalin St. Gori",
							id: "17",
						},
					]
      },
    };
  },
  mounted() {
    // console.log(_.get( this.$store.state.current_content, 'primary.0' ));
  },
  methods:{
    async submitForm(formName){

      let req = {
                  formData: {
                    ...this.ruleForm,
                  },
                  formName: _.get( this.$store.state.current_content, 'primary.0.form_title' ),
                  formType: _.get( this.$store.state.current_content, 'primary.0.slug' ),
                  toEmail: _.get( this.$store.state.current_content, 'primary.0.to_email' ),
      };
      
      if (_.get(this.$store.state.current_content, "primary.0.slug") === "premium-banking") {
        req.formData.branch = this.branchList[_.get(this.$store.state, 'locale')][this.selectedBranch].title;
      }
      let tmp = await this.$fn.postData("main/saveLeadForm", req );

      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.formStatus = 'show-thank-text';
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.ruleForm = {};
      this.formStatus = 'show-form'
      this.selectedBranch = 0;
    },
    onVerify(e) {
      console.log(e);
    }
  }
};
</script>

<style>
.ml-0{ margin-left: 0 !important; }
.form-container .el-form-item.is-error .el-input__inner,
.form-container .el-form-item.is-error .el-input__inner:focus,
.form-container .el-form-item.is-error .el-textarea__inner,
.form-container .el-form-item.is-error .el-textarea__inner:focus,
.form-container .el-message-box__input input.invalid,
.form-container .el-message-box__input input.invalid:focus {
  border-color: #d0aa67;
}
.form-container .el-form-item__error {
  color: #d0aa67;
  font-family: "NotoSansGeorgian-SemiBold", "NotoSans-SemiBold";
  padding-top: 5px;
  position: relative;
  transition: 0.4s;
}
.el-input.is-active .el-input__inner,
.el-input__inner:focus,
.el-textarea__inner:focus {
  border-color: #d0aa67;
}
.form-container .el-form-item__content {
  font-size: 12px;
  font-family: "NotoSansGeorgian-SemiBold", "NotoSans-SemiBold";
  line-height: 17px;
  margin-bottom: 18px;
}
.form-container .el-form-item {
  margin-bottom: 0;
}
.el-button--primary:focus,
.el-button--primary:hover,
.el-button--primary.is-active,
.el-button--primary:active,
.el-button--primary {
  border-color: transparent;
}

.unique-overview .overview-right h3 {
  font-size: 34px;
  font-family: "NotoSansGeorgian-SemiBold", "NotoSans-SemiBold";
  line-height: 40px;
}
.form-container .success-msg {
  opacity: 1;
  pointer-events: all;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
	-moz-appearance: none;
  margin: 0;
}
@media (max-width: 1023px) {
  .business-model .overview-container.reversed {
    flex-direction: column-reverse;
  }

  .business-model .overview-container.reversed .overview-right {
    margin-top: 0;
    margin-bottom: 55px;
  }
}
@media (max-width: 767px) {
  .unique-overview .overview-right h3 {
    font-size: 21px;
  }
}
</style>